/**
 * Represents the mode of color transformation
 */
// eslint-disable-next-line etc/no-const-enum
export const enum ColorTransformDirection {
    /**
     * Transform from light to dark
     */
    LightToDark = 0,

    /**
     * Transform from dark to light
     */
    DarkToLight = 1,
}
